import { render, staticRenderFns } from "./ProductTemplateEdit1.vue?vue&type=template&id=cc77ffe4&"
import script from "./ProductTemplateEdit1.vue?vue&type=script&lang=js&"
export * from "./ProductTemplateEdit1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports